module.exports = __webpack_public_path__ + "static/FY_2022_Investor_Presentation-74eec91d9cc45eecc9a9bd73c08bea1e.pdf";